// Component 4: PaginationControls.jsx
export const PaginationControls = ({ currentPage, totalPages, onPageChange }) => (
    <div className="flex justify-between items-center py-4">
      <button
        className="bg-gray-200 px-4 py-2 rounded"
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
      >
        Prev
      </button>
      <span>Page {currentPage} of {totalPages}</span>
      <button
        className="bg-gray-200 px-4 py-2 rounded"
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
      >
        Next
      </button>
    </div>
  );
  